import { Link } from "react-router-dom";
import "./Menu.css";

function Menu({ isOpenMenu, closeMenu }) {
  return (
    <div
      className={`menu ${isOpenMenu ? "menu_active" : ""}`}
      onClick={closeMenu}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="menu-menu"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close"
          onClick={closeMenu}
          type="button"
          aria-label="Закрыть меню"
        />

        <nav className="footer-container__menu">
          <ul className="footer-container__menu-list">
            <li>
              <a className="footer-container__link" href="#skills" onClick={closeMenu}>
                Чему вы научитесь
              </a>
            </li>
            <li>
              <a className="footer-container__link" href="#description" onClick={closeMenu}>
                Процесс обучения
              </a>
            </li>
            <li>
              <a className="footer-container__link" href="#price" onClick={closeMenu}>
                Стоимость
              </a>
            </li>
            <li>
              <a className="footer-container__link" href="#teacher" onClick={closeMenu}>
                Кто вас обучает
              </a>
            </li>
            <li>
              <a className="footer-container__link" href="#address" onClick={closeMenu}>
                Контакты
              </a>
            </li>
          </ul>
        </nav>

        <ul className="menu__link-list">
          <li>
            <Link className="menu__link" to="/sign-up" onClick={closeMenu}>
              Регистрация
            </Link>
          </li>
          <li>
            <Link className="menu__link menu__link_out" to="/sign-in" onClick={closeMenu}>
              Войти
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Menu;
